// it is designed for displaying bid details related to service providers (SPs) for a specific load in a logistics or transport management system.
import { gql, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import Reactportal from "../../Components/Reactportal/Reactportal";
import LoadDetails from "./LoadDetails";
import "./ResultLP.scss";
import ResultTable from "./ResultTableSP/ResultTable";

// fetcheds load details by ID.
const Get_Load_By_Id = gql`
  query load($id: ID!) {
    load(id: $id) {
      _id
      Unique_Id
      UserId {
        _id
      }
    }
  }
`;

// fetches bid details for service providers for a specific load.
const BIDS_SP_QUERY = gql`
  query BidDetailsForSpForERP($createInput: RequiredBidDetails) {
    BidDetailsForSpForERP(createInput: $createInput) {
      _id
      LoadId
      UserId {
        _id
        Unique_Id
        accType
        firstName
        FullName
        Company_Name
        mobileNumber
        email
        Type_Of_User
        Is_Active
        Root_User
        password
        createdAt
        lastName
        message
      }
      Committed_Vehicles {
        _id
        Advance_Processed
        BidId
        Booking_Confirmed
        Clear_Delivery_Confirmation
        Driver_Name
        Driver_Number
        Loading_Completed
        Reporting_Time
        Unique_Id
        Unloading_Completed
        UserId
        Vehicle_Reached_At_Loading_Point
        Vehicle_Number {
          _id
          Vehicle_No
        }
        Vehicle_Reach_At_Unloading_Point
        Is_Accepted
        Is_Rejected
        Is_Confirmed
      }
      Price
      Rank
      Unique_Id
      No_Of_Vehicle
      Confirm_Qty
      Bid_Note
      createdAt
      updatedAt
    }
  }
`;
// - `fielddata`, `show`, `LoadId`, `totalWeight`, `setShowModal`, `TypeOfPortal`: These props are used to pass data into the component and control its behavior, such as which load's bid details to display and whether the modal is shown.
const BidsSP = ({ fielddata, show, LoadId, totalWeight, setShowModal, TypeOfPortal }) => {
  const [SpData, setSpData] = useState([]);
  const dispatch = useDispatch();
  // to retive bid details abot the load itself
  const { data, refetch } = useQuery(BIDS_SP_QUERY, {
    variables: {
      createInput: { id: LoadId },
    },
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    fetchPolicy: "network-only",
  });
  // to fetch details about the load itself.
  // Both queries use a network-only fetch policy to ensure fresh data is fetched from the server
  let { data: loaddata } = useQuery(Get_Load_By_Id, {
    variables: { id: LoadId },
    fetchPolicy: "network-only",
  });
  const [openItems, setOpenItems] = useState(show);

  // After fetching, it checks if bid details data ('data`) is availabe and updates the local 'SpData` state whth this data.
  useEffect(() => {
    if (data) {
      setSpData(data?.BidDetailsForSpForERP);
    }
  }, [data]);
  // Function to close the modal and clear redux from data. it is triggred when the user wants to close the component.
  const Closeformfunction2 = () => {
    setShowModal();
    setOpenItems(false);
    dispatch({ type: "ClearData", payload: { data: {} } });
  };

  let submit = () => {};

  /* => LoadDetails Component display details to the load based on LoadId
     => ResultTable for each service provider's bid. It passes necessary details like load ID, User details, and commited vehicles data to each ResultTable.
     => PortalFooter Component Renders a footer with aaction buttons. The properties passed to it control it's behavior, but most of them are placeholder in this implementation. indication potential customization points.
  */
  return (
    <Reactportal open={openItems} onClose={Closeformfunction2} TypeOfPortal={"Bids SP"}>
      <div className="mainResultDetailsdiv">
        <LoadDetails LoadId={LoadId} Type={"BidsSP"} />
        <div className="BiddingPage">
          {SpData &&
            SpData.length > 0 &&
            SpData.map((e: any, i) => (
              <ResultTable
                loadId={LoadId}
                LPUserId={loaddata?.load?.UserId?._id}
                userDetails={e?.UserId}
                details={e}
                // awardedData={committedVehicles}
                i={i}
                awardedData={e?.Committed_Vehicles}
                // HandleRefetch={() => {}}
                HandleRefetch={() => refetch()}
              />
            ))}
        </div>
      </div>
      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        submitform={submit}
        submitType={""}
        SaveAndClose={""}
        handleformclose={() => {
          Closeformfunction2();
          setOpenItems(false);
        }}
      />
    </Reactportal>
  );
};

export default BidsSP;
